// extracted by mini-css-extract-plugin
export default {"cardContainer":"EmployeeCreate_cardContainer__7YpgH","container":"EmployeeCreate_container__9Xtyv"};